var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.track.expanded) ? _c('div', {
    staticClass: "track-detail content"
  }, [_c('figure', {
    staticClass: "firstImage"
  }, [_c('img', {
    staticStyle: {
      "min-height": "300px"
    },
    attrs: {
      "src": '/static/img/' + _vm.firstImage.src
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "is-size-7"
  }, [_vm._v(_vm._s(_vm.firstImage.caption))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.track.paragraph)
    }
  }), _vm._v(" "), _vm._l((_vm.moreImages), function(image) {
    return _c('figure', [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: ('/static/img/' + image.src),
        expression: "'/static/img/'+image.src"
      }],
      staticStyle: {
        "min-height": "200px"
      }
    }), _vm._v(" "), _c('figcaption', {
      staticClass: "is-size-7"
    }, [_vm._v(_vm._s(image.caption))])])
  })], 2) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5008fbfc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListenPage/TrackListDetail.vue
// module id = lMa/
// module chunks = 1